import { useMemo } from "react";

import { ICatalogue } from "../../../../apis/useGetCatalogueData/types";
import { useCatalogueContext } from "../../../../contexts/CatalogueContext/CatalogueContext";
import { ICatalogueContext } from "../../../../contexts/CatalogueContext/types";

const NO_DATA: ICatalogue[] = [];

export const usePDPSetItem = (category_ids: number[]) => {
	const selector = useMemo(() => {
		return ({ products }: ICatalogueContext) => {
			return (
				products.filter(
					({ food_supplier_category }) =>
						food_supplier_category && category_ids.includes(Number(food_supplier_category.id))
				) ?? NO_DATA
			);
		};
	}, [JSON.stringify([...category_ids].sort((a, b) => a - b))]);

	const { state: items } = useCatalogueContext(selector);

	return items;
};
